/**
 * Ultimate Debtor
 */

import { default as Switch } from 'antd/es/switch';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

import { useGetCustomerAddress } from 'api';

import { useCurrentOrganisation } from 'hooks/context';

import type { StepFormExtensionProps } from '../utils/types';

export const UltimateDebtorFillOrgInfoSwitch = ({
  step
}: StepFormExtensionProps) => {
  const { setValue } = useFormContext();

  // Organisation information
  const organisation = useCurrentOrganisation();
  const { data: { data: customerAddress } = {} } = useGetCustomerAddress(
    organisation.id
  );

  const setStepValue = useCallback(
    (data: { [s: string]: unknown }) => {
      Object.entries(data).forEach(([key, value]) =>
        setValue(`${step}.${key}`, value, { shouldDirty: true })
      );
    },
    [setValue, step]
  );

  const onSwitch = useCallback(
    (checked: boolean) => {
      if (customerAddress === undefined) {
        return;
      }

      if (checked) {
        setStepValue({
          name: customerAddress.organisation_name,
          country_code: customerAddress.country?.iso,
          address_lines: customerAddress.line1 ?? customerAddress.line2,
          city: customerAddress.city,
          postcode: customerAddress.postal_code,
          type: 'organization'
        });
      } else {
        setStepValue({
          name: '',
          country_code: '',
          address_lines: '',
          city: '',
          postcode: '',
          type: ''
        });
      }
    },
    [customerAddress, setStepValue]
  );

  return (
    <div className="flex gap-4 text-sm">
      <span>Fill with organisation information</span>
      <Switch
        onChange={onSwitch}
        disabled={customerAddress === undefined}
        data-testid="manual-payout-fill-org-info-switch"
      />
    </div>
  );
};
